// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AboutRestaurant Component Styles */
.about-restaurant {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);
}

.about-restaurant__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.about-restaurant__content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

.about-restaurant__content--image-right {
  grid-template-columns: 1.2fr 1fr;
}

.about-restaurant__content--image-left {
  grid-template-columns: 1fr 1.2fr;
}

.about-restaurant__content--image-left .about-restaurant__slider-area {
  order: -1;
}

.about-restaurant__title {
  font-size: 2.5rem;
  font-weight: 400;
  margin-bottom: 2rem;
  color: #4A90E2;
  position: relative;
  padding-bottom: 1rem;
}

.about-restaurant__title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #4A90E2, #87ceeb);
  border-radius: 2px;
}

.about-restaurant__text {
  line-height: 1.7;
  font-size: 1.1rem;
  color: #555;
}

.about-restaurant__paragraph {
  margin-bottom: 1.5rem;
  text-align: justify;
}

.about-restaurant__paragraph:first-child {
  font-size: 1.15rem;
  color: #333;
}

.about-restaurant__paragraph:last-child {
  color: #4A90E2;
  font-weight: 500;
}

/* Old image styles replaced with slider styles */

/* Content without image */
.about-restaurant__content:not([class*="--image"]) .about-restaurant__text-area {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.about-restaurant__content:not([class*="--image"]) .about-restaurant__title::after {
  left: 50%;
  transform: translateX(-50%);
}

/* Responsive Design */
@media (max-width: 968px) {
  .about-restaurant__content--image-right,
  .about-restaurant__content--image-left {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .about-restaurant__content--image-left .about-restaurant__slider-area {
    order: 0;
  }
}

@media (max-width: 768px) {
  .about-restaurant {
    padding: 60px 0;
  }
  
  .about-restaurant__container {
    padding: 0 1.5rem;
  }
  
  .about-restaurant__title {
    font-size: 2rem;
  }
  
  .about-restaurant__text {
    font-size: 1rem;
  }
  
  /* Old image styles removed */
}

@media (max-width: 480px) {
  .about-restaurant__title {
    font-size: 1.6rem;
  }
  
  .about-restaurant__paragraph {
    text-align: left;
  }
}

/* Slider Styles */
.about-restaurant__slider-area {
  position: relative;
}

.about-restaurant__slider {
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 400px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  background: #f8f9ff;
  margin: 0 auto;
}

.about-restaurant__slider-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.about-restaurant__slider-track {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.about-restaurant__slide {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
}

.about-restaurant__slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* Navigation Arrows */
.about-restaurant__slider-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.about-restaurant__slider-arrow:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-50%) scale(1.1);
}

.about-restaurant__slider-arrow--prev {
  left: 15px;
}

.about-restaurant__slider-arrow--next {
  right: 15px;
}

/* Dots Navigation */
.about-restaurant__slider-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}

.about-restaurant__slider-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.about-restaurant__slider-dot:hover {
  transform: scale(1.2);
}

.about-restaurant__slider-dot--active {
  transform: scale(1.3);
}

/* Responsive Slider */
@media (max-width: 768px) {
  .about-restaurant__slider {
    height: 300px;
  }
  
  .about-restaurant__slider-arrow {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
  
  .about-restaurant__slider-arrow--prev {
    left: 10px;
  }
  
  .about-restaurant__slider-arrow--next {
    right: 10px;
  }
  
  .about-restaurant__slider-dots {
    bottom: 15px;
  }
  
  .about-restaurant__slider-dot {
    width: 10px;
    height: 10px;
  }
}

@media (max-width: 480px) {
  .about-restaurant__slider {
    height: 250px;
    border-radius: 8px;
  }
  
  .about-restaurant__slider-arrow {
    width: 35px;
    height: 35px;
    font-size: 16px;
  }
}

/* Service section styles removed - moved to AboutSpecialties */`, "",{"version":3,"sources":["webpack://./src/components/AboutRestaurant.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iDAAiD;;AAEjD,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,+DAA+D","sourcesContent":["/* AboutRestaurant Component Styles */\n.about-restaurant {\n  padding: 80px 0;\n  background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);\n}\n\n.about-restaurant__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.about-restaurant__content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.about-restaurant__content--image-right {\n  grid-template-columns: 1.2fr 1fr;\n}\n\n.about-restaurant__content--image-left {\n  grid-template-columns: 1fr 1.2fr;\n}\n\n.about-restaurant__content--image-left .about-restaurant__slider-area {\n  order: -1;\n}\n\n.about-restaurant__title {\n  font-size: 2.5rem;\n  font-weight: 400;\n  margin-bottom: 2rem;\n  color: #4A90E2;\n  position: relative;\n  padding-bottom: 1rem;\n}\n\n.about-restaurant__title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(90deg, #4A90E2, #87ceeb);\n  border-radius: 2px;\n}\n\n.about-restaurant__text {\n  line-height: 1.7;\n  font-size: 1.1rem;\n  color: #555;\n}\n\n.about-restaurant__paragraph {\n  margin-bottom: 1.5rem;\n  text-align: justify;\n}\n\n.about-restaurant__paragraph:first-child {\n  font-size: 1.15rem;\n  color: #333;\n}\n\n.about-restaurant__paragraph:last-child {\n  color: #4A90E2;\n  font-weight: 500;\n}\n\n/* Old image styles replaced with slider styles */\n\n/* Content without image */\n.about-restaurant__content:not([class*=\"--image\"]) .about-restaurant__text-area {\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.about-restaurant__content:not([class*=\"--image\"]) .about-restaurant__title::after {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n/* Responsive Design */\n@media (max-width: 968px) {\n  .about-restaurant__content--image-right,\n  .about-restaurant__content--image-left {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n  \n  .about-restaurant__content--image-left .about-restaurant__slider-area {\n    order: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .about-restaurant {\n    padding: 60px 0;\n  }\n  \n  .about-restaurant__container {\n    padding: 0 1.5rem;\n  }\n  \n  .about-restaurant__title {\n    font-size: 2rem;\n  }\n  \n  .about-restaurant__text {\n    font-size: 1rem;\n  }\n  \n  /* Old image styles removed */\n}\n\n@media (max-width: 480px) {\n  .about-restaurant__title {\n    font-size: 1.6rem;\n  }\n  \n  .about-restaurant__paragraph {\n    text-align: left;\n  }\n}\n\n/* Slider Styles */\n.about-restaurant__slider-area {\n  position: relative;\n}\n\n.about-restaurant__slider {\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n  height: 400px;\n  overflow: hidden;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  background: #f8f9ff;\n  margin: 0 auto;\n}\n\n.about-restaurant__slider-container {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.about-restaurant__slider-track {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.about-restaurant__slide {\n  flex: 0 0 100%;\n  width: 100%;\n  height: 100%;\n}\n\n.about-restaurant__slide-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n/* Navigation Arrows */\n.about-restaurant__slider-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 10;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.about-restaurant__slider-arrow:hover {\n  background: rgba(255, 255, 255, 1);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.about-restaurant__slider-arrow--prev {\n  left: 15px;\n}\n\n.about-restaurant__slider-arrow--next {\n  right: 15px;\n}\n\n/* Dots Navigation */\n.about-restaurant__slider-dots {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n}\n\n.about-restaurant__slider-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.about-restaurant__slider-dot:hover {\n  transform: scale(1.2);\n}\n\n.about-restaurant__slider-dot--active {\n  transform: scale(1.3);\n}\n\n/* Responsive Slider */\n@media (max-width: 768px) {\n  .about-restaurant__slider {\n    height: 300px;\n  }\n  \n  .about-restaurant__slider-arrow {\n    width: 40px;\n    height: 40px;\n    font-size: 18px;\n  }\n  \n  .about-restaurant__slider-arrow--prev {\n    left: 10px;\n  }\n  \n  .about-restaurant__slider-arrow--next {\n    right: 10px;\n  }\n  \n  .about-restaurant__slider-dots {\n    bottom: 15px;\n  }\n  \n  .about-restaurant__slider-dot {\n    width: 10px;\n    height: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-restaurant__slider {\n    height: 250px;\n    border-radius: 8px;\n  }\n  \n  .about-restaurant__slider-arrow {\n    width: 35px;\n    height: 35px;\n    font-size: 16px;\n  }\n}\n\n/* Service section styles removed - moved to AboutSpecialties */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
